<template>
  <div class="video--content animation-bottom animation-delay-05">

    <div class="video--content__header container column align-items-center justify-content-center">
      <div class="video--content__header__icon animation-top animation-delay-1">
        <img src="@/assets/img/video-heart.svg" width="60" alt="Minds">
      </div>
      <div class="video--content__header__text container wrap align-items-center justify-content-center animation-bottom animation-delay-15">
        <span>WELCOME</span>
        <span class="strong"> {{ user.name }} </span>
      </div>
    </div>

    <div class="video--content__block container column align-items-center justify-content-center">
      <div class="video--content__block_text animation-top animation-delay-2">
        <p>
          Seja bem vindo a <strong>Minds English School</strong>. Assista ao vídeo e saiba um pouco mais sobre nós!
        </p>
      </div>

      <div class="video--content__block_video animation-bottom animation-delay-2 relative">
        <transition name="btn-transition">
          <img src="@/assets/img/video-play.svg" width="60" alt="Minds" class="animation-bottom" @click="$refs['video'].play()" v-if="!isPlaying">
        </transition>
        <video
          src="@/assets/media/initialClass.mp4"
          poster="@/assets/img/postervideo.jpg"
          ref="video"
          @playing="isPlaying = true"
          @pause="isPlaying = false"
          @click="$event.target.pause()"
        />
      </div>

      <div class="video--content__block_btn container">
        <button
          class="btn btn-lg btn-blue gradient-blue btn-full btn-rounded animation-bottom animation-delay-25 margin-right-5"
          @click="$store.commit('setShowPdf', true)"
        >
          ARQUIVOS
        </button>
        <button
          class="btn btn-lg btn-yellow gradient-yellow btn-full btn-rounded animation-bottom animation-delay-25"
          @click="accessPage()"
        >
          ENTRAR <i class="margin-left-5 fas fa-arrow-right"></i>
        </button>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">

  export default {
    data () {
      return {
        isPlaying: false
      }
    },
    components: {
    },
    computed: {
      user () {
        return this.$store.getters['student/GET']
      }
    },
    methods: {
      async accessPage () {
        try {
          await this.$store.dispatch('student/setFirstAccess', false)
          this.$router.replace({ name: 'home' })
        } catch (error) {
          console.warn('Failed to setFirstAccess to true.', error)
        }
      }
    }
  }
</script>

<style media="screen" lang="scss">
  .video--content {
    width: 980px;
    max-width: 90%;
    margin: 0 auto 20px;
    padding: 10px;
    .video--content__header {
      min-height: 140px;
      background-color: #EFEFEF;
      border-radius: 10px 10px 0 0;
      overflow: hidden;
      padding-top: 20px;
      padding-bottom: 20px;
      box-sizing: border-box;
      @media (max-width: 440px){
        margin-top: 60px;
      }
      .video--content__header__text {
        color: #255F83;
        font-size: 29px;
        font-weight: 300;
        line-height: 39px;
        font-weight: 100;
        margin-left: 10px;
        margin-right: 10px;
        text-transform: uppercase;
        .strong {
          font-weight: 900;
          margin-left: 7px;
        }
      }
    }
    .video--content__block {
      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(60%, #C50737), to(#CD1F26));
      background-image: linear-gradient(-180deg, #C50737 60%, #CD1F26);
      border-radius: 0 0 10px 10px;
      padding: 20px;
      box-sizing: border-box;
      .video--content__block_btn {
        margin-top: 20px;
        margin-bottom: 20px;
      }
      .video--content__block_text {
        color: #fff;
        width: 700px;
        max-width: 90%;
        text-align: center;
        margin-bottom: 20px;
        font-size: 14px;
      }
      .video--content__block_video {
        // background: #D8D8D8;
        // background: #C50737;
        width: 684px;
        max-width: 90%;
        overflow: hidden;
        min-height: 387px;
        border-radius: 10px;
        img {
          cursor: pointer;
          position: absolute;
          top: calc(50% - 30px);
          left: calc(50% - 30px);
          z-index: 100;
        }
        video {
          cursor: pointer;
          border-radius: 10px;
          max-width: 100%;
          max-height: calc(100% + 10px);
          min-width: 100%;
          min-height: calc(100% + 10px);
        }
        @media screen and (max-width: 480px) {
          min-height: 130px;
        }
      }
    }
  }

  .btn-transition {
    &-enter-active,
    &-leave-active {
      transition: opacity .2s;
    }
    &-ender,
    &-leave-to {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/video/index.vue